import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';

@Pipe({
  name: 'versionState',
  standalone: true
})
export class VersionStatePipe implements PipeTransform {
  private ready = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_READY');
  private master = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_PUBLISHED');
  private archive = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_ARCHIVE');
  private neverPublished = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_NEVER_PUBLISHED');
  private beingAuthorised = this.translateSvc.instant('VERSIONING.BEING_AUTHORISED_DIAGRAM_LABEL');
  private cancelled = this.translateSvc.instant('VERSIONING.CANCELLED_DIAGRAM_LABEL');

  constructor(private translateSvc: TranslateService) {}

  transform(state: string): string {
    switch (state) {
      case DIAGRAM_VERSION_STATES_ENUM.READY:
        return this.ready;

      case DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED:
        return this.beingAuthorised;

      case DIAGRAM_VERSION_STATES_ENUM.CANCELLED:
        return this.cancelled;

      case DIAGRAM_VERSION_STATES_ENUM.MASTER:
        return this.master;

      case DIAGRAM_VERSION_STATES_ENUM.ARCHIVE:
        return this.archive;

      case DIAGRAM_VERSION_STATES_ENUM.NEVER_PUBLISHED:
        return this.neverPublished;
    }
  }
}
